import { Injectable } from '@angular/core';
import { RootService } from '@app/core/root.service';
import { ItemProps } from '@app/interfaces';
import { Router } from '@angular/router';
import { ApiRequestService } from '@app/core/http/api-request.service';
import { Validators } from '@angular/forms';
import { PermissionsService } from '@app/core/permissions/permissions.service';
import { CustomValidators } from '@app/core/classes/custom-validators/custom-validators';
import { SharedService } from '@app/shared/services/shared.service';
import { ToArabicPipe } from '@app/shared/pipes/toArabic.pipe';

@Injectable({
  providedIn: 'root'
})
export class UsersService extends RootService {
  searchKey = 'keyword';
  id: any;
  constructor(
    router: Router,
    api: ApiRequestService,
    permissionsService: PermissionsService,
    shared: SharedService,
    private toArabicPipe: ToArabicPipe
  ) {
    super(router, api, permissionsService, shared);
    this.permissionsKey = 'user';

    this.lists.position = [
      {
        id: 'driver',
        name: 'Driver'
      },
      {
        id: 'technician',
        name: 'Technician'
      },
      {
        id: 'employee',
        name: 'Employee'
      },
      {
        id: 'administrator',
        name: 'Administrator'
      }
    ];
    this.lists.interface = [
      {
        id: 'web',
        name: 'Web'
      },
      {
        id: 'mobile',
        name: 'Mobile'
      },
      {
        id: 'all',
        name: 'Both'
      }
    ];
  }

  routerPrefix(val: string = '') {
    return val ? val : 'users';
  }

  refactorFilters(filters: any): any {
    super.refactorFilters(filters);
    /** set perPage to 50 */
    filters.per_page = 50;

    return filters;
  }

  refactorItem(item: any) {
    super.refactorItem(item);
    if (item.position === 'administrator') {
      delete item.role;
    }
    return item;
  }
  selectItem(id: any) {
    if (Array.isArray(id)) {
      let user = JSON.parse(sessionStorage.getItem('credentials')) || JSON.parse(localStorage.getItem('credentials'));
      id = id.filter(id => id !== 1 && id !== user.userId);
    }
    if (id.constructor === Array) {
      if (this.selectedItems.length) {
        if (this.selectedItems.length === id.length) {
          id.forEach((y: number) => {
            if (this.selectedItems.find(x => x === y)) {
              const i = this.selectedItems.findIndex(x => x === y);
              this.selectedItems.splice(i, 1);
            } else {
              this.selectedItems.push(y);
            }
          });
        } else {
          id.forEach((y: number) => {
            if (this.selectedItems.find(x => x === y)) {
              // const i = this.selectedItems.findIndex(x => x === y);
              // this.selectedItems.splice(i, 1);
            } else {
              this.selectedItems.push(y);
            }
          });
        }
      } else {
        id.forEach((y: number) => {
          this.selectedItems.push(y);
        });
      }
      this.selectedItems$.next(null);
    } else if (typeof id === 'number') {
      if (this.selectedItems.length) {
        if (this.selectedItems.find(x => x === id)) {
          const i = this.selectedItems.findIndex(x => x === id);
          this.selectedItems.splice(i, 1);
        } else {
          this.selectedItems.push(id);
        }
      } else {
        this.selectedItems.push(id);
      }
      this.selectedItems$.next(null);
    }
  }

  refactorFormBeforeSubmit(formValue: any) {
    formValue['status'] = +formValue['status'];
    formValue['use_mob'] = +formValue['use_mob'];

    return formValue;
  }

  listPrepareOperations(data: any) {
    let user = JSON.parse(sessionStorage.getItem('credentials')) || JSON.parse(localStorage.getItem('credentials'));
    data['data'].forEach((element: any) => {
      element['phone'] = this.toArabicPipe.transform(element['phone']);
      element['active'] = {
        name: element['status'] ? 'نشط' : 'غير نشط',
        value: element['status'],
        icon: 'fiber_manual_record',
        style: {
          color: element['status'] ? '#42B852' : '#C9C9C9'
        }
      };

      element['use_mob'] = {
        name: element['use_mob'] ? 'نشط' : 'غير نشط',
        value: element['use_mob'],
        icon: 'fiber_manual_record',
        style: {
          color: element['use_mob'] ? '#42B852' : '#C9C9C9'
        }
      };
      element['my'] = user ? (user.userId === element['id'] ? true : false) : null;
    });
    return data;
  }
  refactorSelectListsResponse(listPrefix: string, response: any, listPaginate: boolean = false) {
    if (listPrefix === 'roles') {
      if (response.data && response.data.length) {
        response.data = response.data.map(
          (data: any) =>
            <object>{
              ...data,
              name: data.display_name
            }
        );
        if (this.id === 1) response.data = [...response.data];
        else response.data = response.data.filter((d: any) => d.id !== 1);
      }
    }
    return response.data;
  }

  get featureProps(): ItemProps[] {
    return [
      //form only [active]
      {
        name: 'status',
        prop: 'status',
        form: {
          formFieldType: 'toggle',
          Validators: [],
          initValue: true,
          // cssClass: 'users-toggle',
          disabeldIf: {
            key: 'id',
            value: 1
          },
          grid: {
            gt_lg: '50%',
            lt_xl: '50%',
            lt_lg: '50%',
            lt_md: '50%',
            lt_sm: '50%'
          }
        }
      },

      //form [use_mob]
      {
        name: 'use_mob',
        prop: 'use_mob',
        form: {
          formFieldType: 'toggle',
          Validators: [Validators.required],
          initValue: 0,
          // cssClass: 'users-toggle',
          grid: {
            gt_lg: '50%',
            lt_xl: '50%',
            lt_lg: '50%',
            lt_md: '50%',
            lt_sm: '50%'
          },
          disabeldIf: {
            key: 'id',
            value: 1
          }
        }
      },

      //form only [first_name]
      {
        name: 'first_name',
        prop: 'first_name',
        form: {
          formFieldType: 'text',
          Validators: [Validators.required],
          // cssClass: 'first_name',
          maxLength: 50,
          minLength: 3,
          grid: {
            lt_xl: '50%',
            lt_lg: '50%',
            lt_md: '50%',
            lt_sm: '100%',
            gt_lg: '50%'
          },
          disabeldIf: {
            key: 'id',
            value: 1
          }
        }
      },
      //form only [last_name]
      {
        name: 'last_name',
        prop: 'last_name',
        form: {
          formFieldType: 'text',
          Validators: [Validators.required],
          maxLength: 50,
          minLength: 3,
          grid: {
            lt_xl: '50%',
            lt_lg: '50%',
            lt_md: '50%',
            lt_sm: '100%',
            gt_lg: '50%'
          },
          disabeldIf: {
            key: 'id',
            value: 1
          }
        }
      },
      //form only [photo]

      // {
      //   name: 'photo',
      //   prop: 'photo',

      //   form: {
      //     // inputValueType: 'base64_img',
      //     formFieldType: 'img',
      //     placeHolder: 'assets/user@192.png',
      //     cssClass: 'user_image',
      //     Validators: [],
      //     grid: {
      //       lt_xl: '50%',
      //       lt_lg: '50%',
      //       lt_md: '50%',
      //       lt_sm: '100%',
      //       gt_lg: '50%'
      //     }
      //   }
      // },

      //list  [user_name]
      {
        name: 'full_name',
        prop: 'full_name',
        list: {
          sortable: true,
          searchable: true,
          // searchableInline: true,
          filterFieldType: 'text',
          prefix: [
            {
              prop: 'avatar',
              list: {
                width: 50,
                displayType: 'image',
                placeHolder: 'assets/images/icons/user.svg'
              }
            }
          ],
          additionalContent: [
            {
              prop: 'username',
              list: {
                cellCssClass: ' text-gray display-inline-flex'
              }
            }
          ]
        }
      },

      // form [user_name]
      {
        name: 'username',
        prop: 'username',
        form: {
          Validators: [Validators.required],
          formFieldType: 'text',
          minLength: 3,
          maxLength: 50,
          noSpaces: true,
          disabeldIf: {
            key: 'id',
            value: 1
          }
        }
      },
      //list and form [phone]
      {
        name: 'phone',
        prop: 'phone',
        list: {
          cellInnerCssClass: 'arabicFont'
        },
        form: {
          Validators: [Validators.required, CustomValidators.mobileNumber],
          formFieldType: 'text_number',
          grid: {
            lt_xl: '50%',
            lt_lg: '50%',
            lt_md: '50%',
            lt_sm: '100%',
            gt_lg: '50%'
          },
          maxLength: 10,
          minLength: 10,
          disabeldIf: {
            key: 'id',
            value: 1
          }
        }
      },
      //list and form [email]
      {
        name: 'email',
        prop: 'email',
        list: {
          sortable: true,
          searchable: true,
          // searchableInline: true,
          filterFieldType: 'text'
        },
        form: {
          Validators: [Validators.required, Validators.email],
          formFieldType: 'email',
          grid: {
            lt_xl: '50%',
            lt_lg: '50%',
            lt_md: '50%',
            lt_sm: '100%',
            gt_lg: '50%'
          },
          disabeldIf: {
            key: 'id',
            value: 1
          }
        }
      },
      // form [password]
      {
        name: 'password',
        prop: 'password',
        form: {
          Validators: [Validators.required, Validators.pattern(/^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$/)],
          hiddenEdit: true,
          formFieldType: 'password',
          minLength: 8,
          // maxLength: 10,
          grid: {
            lt_xl: '50%',
            lt_lg: '50%',
            lt_md: '50%',
            lt_sm: '100%',
            gt_lg: '50%'
          },
          disabeldIf: {
            key: 'id',
            value: 1
          }
        }
      },

      //list and form [role]
      {
        name: 'role',
        prop: 'role',
        list: {
          sortable: true,
          searchable: false,
          // searchableInline: true,
          filterFieldType: 'text'
        },
        form: {
          Validators: [Validators.required],
          formFieldType: 'ng_select',
          listPrefix: 'roles',
          dataUrl: 'roles',
          disabeldIf: {
            key: 'id',
            value: 1
          }
          // cssClass: 'multi_select_details'
        }
      },
      {
        name: 'status',
        prop: 'active.name',
        list: {
          displayType: 'text_with_icon',
          sortable: true,
          filterFieldType: 'text',
          icon: {
            name: 'active.icon',
            style: 'active.style',
            beforeText: true
          }
        }
      },
      {
        name: 'use_mob',
        prop: 'use_mob.name',
        list: {
          displayType: 'text_with_icon',
          sortable: true,
          filterFieldType: 'text',
          icon: {
            name: 'use_mob.icon',
            style: 'use_mob.style',
            beforeText: true
          }
        }
      }
    ];
  }
}
